import { useContext } from "react";
import { Navigate, useParams } from "react-router-dom";
import { AuthContext } from "./context/AuthContext";
import DataContext from "./context/DataContext";

/**
 * restrict route access based on roles
 */
const PrivateRoute = ({ children, allowedRoles }) => {
    const { user, userReady } = useContext(AuthContext);
    const { isServerDown } = useContext(DataContext);
    const { bUser } = useParams();

    if (!userReady) return null;
    // reroute if no user or user not authorized and all only if server is not down
    if (
        !isServerDown &&
        (!user || !allowedRoles.includes(user.userRole.toLowerCase()))
    ) {
        return <Navigate to={`/${bUser}/pos/unauthorized`} />;
    }

    return children;
};

export default PrivateRoute;
